export enum AvailableLanguage {
    EnGb = 'en-gb',
    EnUs = 'en-us',
    RuRu = 'ru-ru',
    EsEs = 'es-es',
    FrFr = 'fr-fr',
}

/**
 * Converts the app language code ('ru-ru') to a BCP 47 tag for the `lang` attribute ('ru-RU')
 */
export function toHtmlLang(language: string): string {
    const [primary, region]: string[] = (language || '').split('-');

    return region ? `${primary.toLowerCase()}-${region.toUpperCase()}` : primary.toLowerCase();
}
